import React from 'react';

const QueuedAutomationsBanner = ({ queuedCount, onDismiss, onUpgrade }) => {
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl bg-blue-50/80 dark:bg-blue-900/10 border border-blue-200/60 dark:border-blue-700/20">
      {/* Pulsing dot */}
      <span className="relative flex-shrink-0 flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-400" />
      </span>

      {/* Text */}
      <p className="flex-1 text-sm text-gray-600 dark:text-gray-400">
        <span className="font-semibold text-blue-700 dark:text-blue-300">{queuedCount}</span> automation{queuedCount !== 1 ? 's' : ''} waiting in queue — upgrade for more parallel browsers
      </p>

      {/* CTA */}
      <button
        onClick={onUpgrade}
        className="flex-shrink-0 text-xs font-semibold bg-gradient-to-r from-blue-400 via-cyan-400 to-purple-400 bg-clip-text text-transparent hover:from-blue-500 hover:via-cyan-500 hover:to-purple-500 transition-all"
      >
        Upgrade
      </button>

      {/* Dismiss */}
      <button
        onClick={onDismiss}
        className="flex-shrink-0 p-0.5 text-gray-400 dark:text-gray-600 hover:text-gray-600 dark:hover:text-gray-400 transition-colors"
      >
        <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default QueuedAutomationsBanner;
